import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ImageConversionId = Brand<number, 'ImageConversionId'>;
export const ImageConversionId = createBranded<ImageConversionId>();
